import { render, staticRenderFns } from "./StrongFamiliesLayout.vue?vue&type=template&id=0bf7544d&scoped=true&"
import script from "./StrongFamiliesLayout.vue?vue&type=script&lang=js&"
export * from "./StrongFamiliesLayout.vue?vue&type=script&lang=js&"
import style0 from "./StrongFamiliesLayout.vue?vue&type=style&index=0&id=0bf7544d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf7544d",
  null
  
)

export default component.exports